module.exports = __webpack_public_path__ + "img/linea.8a2d98ce.png";